/** StageActionContent — renders `stage_action` entries (an arc stage action executing). */
import React from 'react';
import { useTranslation } from 'localization';
import { TimelineEvent } from 'types/timeline';

interface Props {
  event: TimelineEvent;
}

const StageActionContent: React.FC<Props> = ({ event }) => {
  const { t } = useTranslation();
  const payload = (event.payload ?? {}) as { actionId?: string; actionType?: string; status?: string };

  return (
    <div className="timeline-event-content">
      <span className="timeline-event-content__text">
        {t('timeline.eventContent.stageAction', {
          action: payload.actionId ?? payload.actionType ?? '',
          status: payload.status ?? '',
        })}
      </span>
    </div>
  );
};

export default StageActionContent;
